import type { FaireProductEntity } from "../../entity_types/product";

export const p_egsr952r7r: FaireProductEntity = {
  token: "p_egsr952r7r",
  type: "product",
  name: "rocky's matcha Bamboo Whisk",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/b4045f9d72b53f3f9c8a1ad27fe6908fe90e37f392cdae1e0354ee64a7defbf9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e7d557d88e84cd6fbe4d335a590770037988e3650be3f8228d9239eeb8144de.jpeg",
    "https://cdn.faire.com/fastly/ea702271fb796b8b1c4d1c67914965d00e3ca41e5521ad17a000621b341d878f.jpeg"
  ],
  priceDollars: 14,
  description: "A bamboo whisk is essential to the matcha experience. This bamboo matcha whisk is made from light bamboo, ideal for both usucha (thin matcha) and koicha (thick matcha). Whisk is packaged in a rocky's matcha cardboard tube.\n\nWe recommend that you bloom your matcha whisk before every use and always let it air dry, or on a whisk stand, ideally.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:20.968Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
